import React from 'react';

interface ErrorBoundaryProps {
  // Wechselt bei jeder Navigation, damit nach einem Fehler die nächste Seite wieder normal rendert
  resetKey?: string;
  // Name des Bereichs für die Fehler-Mail
  name?: string;
  // Nur diesen Bereich ausblenden, ohne Hinweis und ohne ReactSafeMode/Neuladen
  silent?: boolean;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

// Fängt Render-Fehler der Seiten ab, damit nie eine komplett weiße Seite stehen bleibt
export default class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, info: any) {
    try {
      // pushError.js ist nicht im SSR-Build, daher über den globalen Helper aus ReactEntry
      (window as any).historyHelper?.pushError('ErrorBoundary', {
        name: this.props.name,
        message: error?.message,
        stack: error?.stack,
        componentStack: info?.componentStack,
        url: window.location.href,
      });
    } catch {}

    if (this.props.silent) return;

    // Wie bei Fehler im hydrate (views/index.js): 1 Min. ReactSafeMode setzen
    // und neu laden, dann liefert der Server die Seite ohne React aus.
    // Kurz warten, damit der pushError-Request noch rausgeht.
    try {
      let d = new Date();
      d.setTime(d.getTime() + 1 * 60 * 1000);
      document.cookie =
        'ReactSafeMode=1;expires=' + d.toUTCString() + ';path=/';
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch {}
  }

  componentDidUpdate(prevProps: ErrorBoundaryProps) {
    if (this.state.hasError && prevProps.resetKey != this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    if (this.props.silent) return null;

    return (
      <div
        id="errorBoundary"
        style={{ padding: '40px 16px', textAlign: 'center' }}
      >
        <h2>Die Seite konnte leider nicht geladen werden.</h2>
        <p>Bitte versuchen Sie es erneut.</p>
        <p>
          <button
            onClick={() => {
              this.setState({ hasError: false });
            }}
          >
            Erneut versuchen
          </button>{' '}
          <button
            onClick={() => {
              window.location.reload();
            }}
          >
            Seite neu laden
          </button>
        </p>
        <p>
          <a href="/">Zur Startseite</a>
        </p>
      </div>
    );
  }
}
